export default {
  messages: {
    en: {
      share: 'Share {name} loan with your friends:',
    },
  },
}
